import type { UploadItem } from 'box-ui-elements/es/common/types/upload';
import type { FormValidationError } from '../../../FormValidator';
import type { Uploader } from '../../../Uploader';
import type { ItemQueue } from '../../../ItemQueue';
import type { Action } from '../../../../../types/context-action/action';

export const UPLOAD_FIELD_ACTIONS = {
  ADD_ITEMS: 'ADD_ITEMS',
  ADD_ITEMS_RESOLVED: 'ADD_ITEMS_RESOLVED',
  ITEMS_FILTERED_FROM_ADD: 'ITEMS_FILTERED_FROM_ADD',
  REMOVE_ITEM: 'REMOVE_ITEM',
  REMOVE_ITEM_RESOLVED: 'REMOVE_ITEM_RESOLVED',
  UPLOAD_IN_PROGRESS: 'UPLOAD_IN_PROGRESS',
  UPLOAD_PROGRESS_UPDATE: 'UPLOAD_PROGRESS_UPDATE',
  ON_ALL_FILES_UPLOADED: 'ON_ALL_FILES_UPLOADED',
  TOGGLE_UPLOAD_MANAGER: 'TOGGLE_UPLOAD_MANAGER',
  UPLOAD_FIELD_FILE_DESCRIPTION_ON_CHANGE:
    'UPLOAD_FIELD_FILE_DESCRIPTION_ON_CHANGE',
  TOO_MANY_FILES: 'TOO_MANY_FILES',
  FILE_SIZE_LIMIT_EXCEEDED: 'FILE_SIZE_LIMIT_EXCEEDED',
  INVALID_FILE_NAME: 'INVALID_FILE_NAME',
} as const;

export type AddItemsAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.ADD_ITEMS,
  {
    id: string;
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2709
    items: Array<UploadItem>;
  }
>;

export type AddItemsResolvedAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.ADD_ITEMS_RESOLVED,
  {
    id: string;
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2709
    items: Array<UploadItem>;
    itemQueue: ItemQueue;
    errorId?: FormValidationError;
  }
>;

export type ItemsFilteredFromAddAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.ITEMS_FILTERED_FROM_ADD
>;

export type RemoveItemAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.REMOVE_ITEM,
  {
    id: string;
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2709
    item: UploadItem;
  }
>;

export type RemoveItemResolvedAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.REMOVE_ITEM_RESOLVED,
  {
    id: string;
    itemQueue: ItemQueue;
    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2709
    items?: UploadItem[];
    errorId?: FormValidationError;
  }
>;

export type UploadInProgressAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.UPLOAD_IN_PROGRESS,
  {
    uploader: Uploader;
  }
>;

export type UploadProgressUpdateAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.UPLOAD_PROGRESS_UPDATE
>;

export type OnAllFilesUploadedAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.ON_ALL_FILES_UPLOADED
>;

export type ToggleUploadManagerAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.TOGGLE_UPLOAD_MANAGER
>;

export type UploadFieldFileDescriptionOnChangeAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.UPLOAD_FIELD_FILE_DESCRIPTION_ON_CHANGE,
  {
    id: string;
    newValue: string;
    errorId?: FormValidationError;
  }
>;

export type TooManyFilesAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.TOO_MANY_FILES
>;

export type FileSizeLimitExceededAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.FILE_SIZE_LIMIT_EXCEEDED
>;

export type InvalidFileNameAction = Action<
  typeof UPLOAD_FIELD_ACTIONS.INVALID_FILE_NAME
>;

export type UploadFieldAction =
  | AddItemsAction
  | AddItemsResolvedAction
  | ItemsFilteredFromAddAction
  | RemoveItemAction
  | RemoveItemResolvedAction
  | UploadInProgressAction
  | UploadProgressUpdateAction
  | OnAllFilesUploadedAction
  | ToggleUploadManagerAction
  | UploadFieldFileDescriptionOnChangeAction
  | TooManyFilesAction
  | FileSizeLimitExceededAction
  | InvalidFileNameAction;
